// extracted by mini-css-extract-plugin
export default {"header":"public-top-header_header__CLSeH"};